const SvgLoss = (props) => (
  <svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-1-1h18v18H-1z" />
      <path
        d="M.5 4v11.5H12l-.5-.5a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5L.5 4z"
        stroke="currentColor"
      />
      <path
        d="M7.16 0v1H5v2.16H4V1a1 1 0 0 1 1-1h2.16zm1.5 0h2.68v1H8.66V0zm4.18 0H15a1 1 0 0 1 1 1v2.16h-1V1h-2.16V0zM16 4.66v2.68h-1V4.66h1zm0 4.18V11a1 1 0 0 1-1 1h-2.16v-1H15V8.84h1zM11.34 12H8.66v-1h2.68v1zm-4.18 0H5a1 1 0 0 1-1-1V8.84h1V11h2.16v1zM4 7.34V4.66h1v2.68H4z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export default SvgLoss
